export const SET_ADD_ACCOUNT_TEXT = 'USERS_TEXTS_SET_ADD_ACCOUNT_TEXT'
export const SET_ADD_ACCOUNT_TOOLTIP_TEXT = 'USERS_TEXTS_SET_ADD_ACCOUNT_TOOLTIP_TEXT'
export const SET_PLAY_TEXT = 'USERS_TEXTS_SET_PLAY_TEXT'
export const SET_PLAY_TOOLTIP_TEXT = 'USERS_TEXTS_SET_PLAY_TOOLTIP_TEXT'
export const SET_PIN_TOOLTIP_TEXT = 'USERS_TEXTS_SET_PIN_TOOLTIP_TEXT'
export const SET_UNPIN_TOOLTIP_TEXT = 'USERS_TEXTS_SET_UNPIN_TOOLTIP_TEXT'
export const SET_START_CLIENT_TOOLTIP_TEXT = 'USERS_TEXTS_SET_START_CLIENT_TOOLTIP_TEXT'
export const SET_STOP_CLIENT_TOOLTIP_TEXT = 'USERS_TEXTS_SET_STOP_CLIENT_TOOLTIP_TEXT'
export const SET_PROFILE_TOOLTIP_TEXT = 'USERS_TEXTS_SET_PROFILE_TOOLTIP_TEXT'
export const SET_LOGOUT_TOOLTIP_TEXT = 'USERS_TEXTS_SET_LOGOUT_TOOLTIP_TEXT'
export const SET_ERROR_AUTO_REFRESH_TEXT = 'USERS_TEXTS_SET_ERROR_AUTO_REFRESH_TEXT'
export const SET_ERROR_REFRESHING_TEXT = 'USERS_TEXTS_SET_ERROR_REFRESHING_TEXT'
export const SET_TEXTS = 'USERS_TEXTS_SET_TEXTS'



// WEBPACK FOOTER //
// ./src/features/Users/data/texts/constants.js